import NotificationCenter from "./notifications/NotificationCenter";

const Notifications = () => <NotificationCenter />;

export default Notifications;
